import React, { PureComponent, Fragment } from 'react';
import * as RBT from 'react-bootstrap';
import classnames from 'classnames';
import validateUserProfile from '../../../Validations/userProfile';
import AlertWrapper from '../../Common/AlertWrapper';
import AlertWrapperSuccess from '../../Common/AlertWrapperSuccess';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { logout } from '../../../Store/actions/loginActions';
import { AJAX_REQUEST, sentryErrorLog } from '../../../Constants/AppConstants';

class UserDetails extends PureComponent {
    constructor(props) {
        super(props);
        this.handleChange1 = this.handleChange1.bind(this);
        this.onSubmitUserDetails = this.onSubmitUserDetails.bind(this);
        this.onValueChange = this.onValueChange.bind(this);
        this.state = {
            action_btn_label: false,
            userDetailsModalShow: false,
            first_name: "",
            last_name: "",
            displayname: "",
            email: "",
            timezone_status: "",
            time_zone: "",
            country: null,
            timezone: null,

            errors: {},
            isValid: false,
            isLoading: false,
            isFormValid: true,
            server_message: '',
            value: null,
            status: 2,
            status_tz: 0,
            countries: [],
            timezones: [],
            country_timezone: [],
        }
    }

    componentDidMount() {
        this.getUserDetails();
    }

    // user details modal
    userDetailsModal = (visibleStatus) => {
        AJAX_REQUEST("POST", "operator/get_country", {}).then(results => {

            // Sentry Log create
            sentryErrorLog(results);

            const response = JSON.parse(results.response.data);
            if (parseInt(results.response.code) === 1000) {
                this.setState({
                    isLoaded: true,
                    countries: response ? response : [],
                    errorMsg: ''
                });
            } else {
                this.setState({
                    loading: false,
                    countries: [],
                    errorMsg: results.response.message
                });
            }

        });
        this.setState({
            userDetailsModalShow: visibleStatus,
            errors: {},
            isValid: false,
            isLoading: false,
            isFormValid: true,
            server_message: ''
        });
    }


    getTimezones = (country_id) => {
        const data = {
            country_id: (country_id) ? parseInt(country_id) : ''
        };


        AJAX_REQUEST("POST", "operator/get_timezone_new", data).then(results => {

            // Sentry Log create
            sentryErrorLog(results);

            const response = JSON.parse(results.response.data);
            if (parseInt(results.response.code) === 1000) {
                this.setState({
                    loading: false,
                    country_timezone: response ? response : [],
                    errorMsg: ''
                });
            } else {
                this.setState({
                    loading: false,
                    country_timezone: [],
                    errorMsg: results.response.message
                });
            }

        });
        this.setState({
            errors: {},
            isValid: false,
            isLoading: false,
            isFormValid: true,
            server_message: '',

        });
    }

    changeHandler = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }


    radioHandler = (status) => {
        this.setState({ status });
    }
    changeHandlerCountry = (e) => {
        const country_id = e.target.value;

        this.getTimezones(country_id);
        this.setState({ status_tz: 1, country_id: country_id });

    }
    onValueChange(event) {
        this.setState({
            selectedOption: event.target.value
        });
    }

    handleChange1(e) {
        this.setState({ timezone_v: e.target.value });
    }
    timeOut = (timedata) => {
        setTimeout(function () {
            this.setState({
                userDetailsModalShow: false,
                success_alert_wrapper_show: false,
                server_message: ''
            });
        }.bind(this), timedata);
    }

    //get operator account details
    getUserDetails = () => {
        AJAX_REQUEST("POST", "operator/details", {}).then(results => {

            // Sentry Log create
            sentryErrorLog(results);

            const response = results.response;
            if (parseInt(results.response.code) === 1000) {
                this.setState({
                    first_name: response.data.first_name,
                    last_name: response.data.last_name,
                    displayname: response.data.displayname,
                    email: response.data.email,
                    time_zone: response.data.timezone,
                    country_id: response.data.country_id,
                    status: response.data.country_id > 0 ? 1 : 2,
                    status_tz: response.data.country_id > 0 ? 1 : 2,
                    selectedOption: response.data.country_id === 0 || response.data.country_id === '' ? 'dynamic' : 'static'
                });
            }
            this.getTimezones(this.state.country_id);
        });
    }
    //for user details
    onSubmitUserDetails = (e) => {
        e.preventDefault();
        this.setState({ action_btn_label: true })
        let timez = '';
        if (this.state.timezone_v !== '' || this.state.timezone_v !== undefined) {
            timez = this.state.timezone_v;
        } else if (this.state.time_zone === undefined || this.state.time_zone === '') {
            timez = this.state.country_timezone[0];
        } else {
            timez = this.state.time_zone;
        }

        var postdata = {
            first_name: this.state.first_name,
            last_name: this.state.last_name,
            displayname: this.state.displayname,
            email: this.state.email,
            timezone_status: this.state.selectedOption,
            time_zone: timez,
            country_id: this.state.country_id,
        }

        const val_return = validateUserProfile(postdata);
        this.setState(val_return);

        if (val_return.isValid) {
            this.setState({ errors: {}, isLoading: true });

            AJAX_REQUEST("POST", "operator/updateInfo", postdata).then(results => {

                // Sentry Log create
                sentryErrorLog(results);

                const response = results.response;
                if (parseInt(response.code) === 1000) {
                    this.setState({
                        server_message: response.message,
                        isFormValid: true,
                        isLoading: false,
                        success_alert_wrapper_show: true,
                        action_btn_label: false
                    });
                    this.timeOut(5000);
                    window.location.reload(false);
                } else {
                    this.setState({
                        server_message: response.message,
                        isFormValid: false,
                        isLoading: false,
                        success_alert_wrapper_show: false,
                        action_btn_label: false
                    });
                }
            });
        } else {
            this.setState({ action_btn_label: false });
        }
    }

    render() {
        const mystyle = { padding: "10px", border: "1px solid #ccc", borderRadius: "4px", margin: "0px 0px 10px 0px" };
        const mystyle1 = { padding: "10px", border: "1px solid #ccc", borderRadius: "4px" };
        const { countries, country_timezone, status, status_tz } = this.state;
        const { errors, server_message, success_alert_wrapper_show } = this.state;
        const full_state = this.state;
        const errors_data = server_message;
        let country_checked = full_state.country_id;
        let tz_checked = full_state.time_zone;
        let countriesList = countries.length > 0
            && countries.map((item) => {
                return (
                    <option value={item.id} selected={country_checked === item.id}>{item.name}</option>
                )
            }, this);



        return (
            <Fragment>
                <li className="user-details-modal"> <button className="nav-link" onClick={() => this.userDetailsModal(true)}>Welcome <span>{full_state.displayname}</span></button></li>

                {/*-- Start User Details Modal --*/}
                <RBT.Modal className="live-chat-modal user-details-modal" centered show={this.state.userDetailsModalShow} onHide={() => this.userDetailsModal(false)} >
                    <RBT.Modal.Header closeButton>
                        <RBT.Modal.Title>ACCOUNT DETAILS</RBT.Modal.Title>
                    </RBT.Modal.Header>
                    <RBT.Modal.Body>
                        <div className="">
                            <form onSubmit={this.onSubmitUserDetails} style={{ border: '0' }} method="post" className="edit_account_form action_form" encType="multipart/form-data">
                                <AlertWrapper errors_data={errors_data} isFormValid={this.state.isFormValid} />
                                <AlertWrapperSuccess errors_data={errors_data} success_alert_wrapper_show={success_alert_wrapper_show} />
                                <div className="inline-field-container">
                                    <div className="form-group name_field">
                                        <label className={classnames(null, { 'pl_error_label': errors.first_name })} htmlFor="first_name">First Name <span className="required">*</span></label>
                                        <input onChange={this.changeHandler} type="text" className={classnames("cus_field", { 'pl_error_input': errors.first_name })} name="first_name" id="first_name" value={full_state.first_name} />
                                    </div>
                                    <div className="form-group name_field">
                                        <label className={classnames(null, { 'pl_error_label': errors.last_name })} htmlFor="last_name">Last Name <span className="required">*</span></label>
                                        <input onChange={this.changeHandler} type="text" className={classnames("cus_field", { 'pl_error_input': errors.last_name })} name="last_name" id="last_name" value={full_state.last_name} />
                                    </div>
                                </div>

                                <div className="clearfix"></div>
                                <div className="form-group">
                                    <label className={classnames(null, { 'pl_error_label': errors.displayname })} htmlFor="displayname">Display name <span className="required">*</span></label>
                                    <input onChange={this.changeHandler} type="text" className={classnames("cus_field", { 'pl_error_input': errors.displayname })} name="displayname" id="displayname" value={full_state.displayname} />
                                    <small><em>This will be how your name will be displayed in the account section and in reviews</em></small>
                                </div>
                                <div className="form-group">
                                    <label className={classnames(null, { 'pl_error_label': errors.email })} htmlFor="email">Email address <span className="required">*</span></label>
                                    <input onChange={this.changeHandler} type="email" className={classnames("cus_field", { 'pl_error_input': errors.email })} name="email" id="email" value={full_state.email} />
                                </div>

                                <div className="form-group">
                                    <h3 className="montserrat page-title"> Update Timezone</h3>
                                </div>
                                <div className="form-group">
                                    <div className="radio">
                                        <label>
                                            <input
                                                type="radio"
                                                value={"static"}
                                                name="selectedOption"
                                                checked={this.state.selectedOption === "static"}
                                                onChange={this.onValueChange}
                                                onClick={(e) => this.radioHandler(1)}
                                            />
                                            <span>  Country Based</span>
                                        </label>
                                    </div>
                                    <div className="radio">
                                        <label>
                                            <input
                                                type="radio"
                                                value={"dynamic"}
                                                name="selectedOption"
                                                checked={this.state.selectedOption === "dynamic"}
                                                onChange={this.onValueChange}
                                                onClick={(e) => this.radioHandler(2)}
                                            />
                                            <span>  IP Based </span>
                                        </label>
                                    </div>
                                </div>

                                {status === 1 ? <div className="form-group">
                                    <label className="" htmlFor="country">Country<span className="required">*</span> </label>
                                    <select className="w-100" onChange={this.changeHandlerCountry} name="country" id="country" style={mystyle}>

                                        {countriesList}
                                    </select>   <br />

                                    {status_tz === 1 ?
                                        <select className="w-100" name="time_zone" required value={this.state.value} onChange={this.handleChange1} style={mystyle1}>
                                            <option value=""> Select Time Zone</option>
                                            {country_timezone && country_timezone.length > 0
                                                && country_timezone.map((val, i) => {

                                                    return (

                                                        <option key={Math.random()} value={val} selected={tz_checked === val} >{val}</option>
                                                    )
                                                }, this)}
                                        </select> : ''}

                                </div> : ''}

                                <div className="">
                                    <button type="submit" disabled={this.state.isLoading} className="roboto_condensed cus_button" name="login" value="Login"> {this.state.action_btn_label ? "Saving..." : "Save Changes"} </button>
                                </div>
                            </form>
                        </div>
                    </RBT.Modal.Body>
                </RBT.Modal>
                {/*-- End User Details Modal --*/}

            </Fragment>
        );
    }
}

UserDetails.propTypes = {
    logout: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired
}

function mapStateToProps(state) {
    return {
        auth: state.auth
    };
}

export default connect(mapStateToProps, { logout })(UserDetails);